window.bundle = window.bundle || {};

bundle.popup = (function () {
    var popupBundle = '#sidebar-bundle',
        $button = $('.bundle-float-next-btn'),
        $headerTitle = $('.bundle-sidebar-header'),
        $closeBtn = $('.bundle-close-btn'),
        $overlay = $('.sidebar-bundle-overlay'),
        isBundle = $(popupBundle).length === 1 ? true : false;
    if (isBundle) {
        $button.on('click', function () {
            $("body").addClass('bundle-modal-active');
        })
        $overlay.on('click', function () {
            $("body").removeClass('bundle-modal-active');
        })
        if ($(document).width() < 992) {
            $headerTitle.on('click', function () {
                $("body").removeClass('bundle-modal-active');
            })
        } else {
            $closeBtn.on('click', function () {
                $("body").removeClass('bundle-modal-active');
            })
        }
    }
})()

bundle.custom = (function () {
    const paginate = $(`.bundle-pagination`);
    const content = $(`.bundle-paginate-content`);
    const pageLoader = $(`.js-loading`);
    const sortBy = $(`#bundle-sortby`);
    const atcBtnSideBar = $('.bundle-add-to-cart-btn');
    const floatCartCount = $('.bundle-float-cart-count');
    const sellingPlanInput = ".bundle-purchase-option-input"
    if (!paginate.length || !content.length) return;

    const apollo = {
        collections: {},
        cart: {},
        storageKey: 'bundleCart',
        updateCartStorage: function () {
            localStorage.setItem(this.storageKey, JSON.stringify(this.cart));
        },
        syncStorage: async function () {
            await fetch("/cart.js").then(res => res.json()).then(data => {
                this.cart = JSON.parse(localStorage.getItem(this.storageKey) ?? "{}");
                data.items.forEach(item => {
                    if (item.properties && item.properties._bundle_item) {
                        if (!this.cart[item.variant_id]) {
                            delete this.cart[item.variant_id];
                        } else {
                            this.cart[item.variant_id] = {
                                ...this.cart[item.variant_id],
                                quantity: item.quantity
                            }
                        }
                    }
                });
                this.updateCartStorage();
                this.renderCartItems();
                this.calculateCartTotal();
            });
        },
        showSuccessAlert: function (message) {
            theme.alert.new('Success', message, 3000, 'notice');
        },
        fetchProductHtml: async function (handle, page = null, sortKey = null) {
            const res = await fetch(`/collections/${handle}?section_id=product-grid-bundle-collection&sort_by=${sortKey}&page=${page}`);
            const html = await res.text();

            // Convert HTML string -> DOM to extract only the product card
            const doc = new DOMParser().parseFromString(html, "text/html");

            const classes = content.attr("data-grid_classes")
            const wrap = doc.querySelector("#shopify-section-product-grid-bundle-collection");
            wrap.querySelectorAll(".bundle-product").forEach(el => {
                el.className = `bundle-product ${classes}`;
            });
            return wrap.innerHTML;
        },
        isOnetime: function(){
            return $(`${sellingPlanInput}:checked`).val() === "onetime" || !$(sellingPlanInput).val()
        },
        generateSubscriptionDis: function(){
            return {
                discount:{
                    value: 10,
                    type: 'percentage'
                },
                attr: {}
            }
        },
        calculateCartTotal: function () {
            let total = 0;
            let quantity = 0;
            for (const key in this.cart) {
                const item = this.cart[key];
                total += item.variant.price * item.quantity;
                quantity += item.quantity;
            }
            const subDis = this.generateSubscriptionDis().discount;
            let discountedPrice = total;
            let discount = null;

            if(!this.isOnetime() && subDis){
                discount = subDis
            }
            if(discount){
                discountedPrice = Math.max(total - (discount.type === 'percentage' ? (total * discount.value)/100 : discount.value), 0);
            }
            const title = $(`${sellingPlanInput}[value="subscription"]`).parents(".bundle-purchase-option").find('.bundle-purchase-option-name')
            title.find(".save-badge").remove();

            if(subDis){
                const amount = subDis.type == 'percentage' ? `${subDis.value}%` : theme.Currency.formatMoney(subDis.value * 100, this.getCurrencyFormat());
                $(title).append(`<span class="save-badge">Save ${amount}</span>`)
            }

            $(`.bundle-float-total-amount, .bundle-total-amount`).text(theme.Currency.formatMoney(discountedPrice, this.getCurrencyFormat()));
            floatCartCount.text(quantity);
            $(`.bundle-float-total-amount, .bundle-total-amount`).find('s').remove()
            if(discountedPrice < total){
                $(`.bundle-float-total-amount, .bundle-total-amount`).append(`<s class="bundle-strike-through">${theme.Currency.formatMoney(total, this.getCurrencyFormat())}</s>`)
            }
        },
        handleRemoveProduct: function (removeBtnSelector) {
            const btn = $(removeBtnSelector);
            const variantId = btn.attr('data-variant');
            const item = this.cart[variantId];
            if (!item) return;

            delete this.cart[variantId];
            this.showSuccessAlert(`Removed ${item.product.title}${item.product.variants.length > 1 ? ` - ${item.variant.title}` : ''} from cart.`);

            this.calculateCartTotal();
            this.renderCartItems();
            this.makeCartNeedToUpdate();
            this.updateCartStorage();
        },
        renderCartItems: function () {
            const cartContainer = $(`.bundle-products-list`);
            let html = '';
            let qtyController = (variantID, qty) => `<div class="bundle-qty-control">
      <button class="bundle-qty-btn bundle-qty-btn-minus" data-variant="${variantID}"><i class="icon-minus"></i></button>
        <input type="text" class="bundle-qty-input" value="${qty}" data-variant="${variantID}">
      <button class="bundle-qty-btn bundle-qty-btn-plus" data-variant="${variantID}"><i class="icon-plus"></i></button>
      </div>`

            for (const key in this.cart) {
                const item = this.cart[key];
                const imageSrc = item.variant.featured_image?.src || item.product.featured_image;
                const image = imageSrc ? imageSrc.replace(/(\.[^.]*)$/, '_240x240$1') : '';
                const price = theme.Currency.formatMoney(item.variant.price * item.quantity, this.getCurrencyFormat());
                html += `
        <div class="bundle-product-item">
            <img src="${image}" alt="${item.product.title}" class="bundle-product-image">
            <div class="bundle-product-info">
              ${qtyController(item.variant.id, item.quantity)}
              <h4 class="bundle-product-name">${item.product.title}</h4>
              ${item.product.variants.length > 1 ? `<span class="bundle-product-variant d-block">${item.variant.title}</span>` : ''}
              <span class="bundle-product-price">${price}</span>
            </div>
            <button class="bundle-remove-product" data-variant="${item.variant.id}">×</button>
          </div>
        `
            }

            if (html === '') {
                cartContainer.html(`<div class="bundle-product-empty">${cartContainer.attr("data-empty_txt")}</div>`)
                atcBtnSideBar.addClass("btn-disabled");
            } else {
                cartContainer.html(html);
                atcBtnSideBar.removeClass("btn-disabled");
            }
            this.updateSubscriptionFrequency();
        },
        makeCartNeedToUpdate: function () {
            atcBtnSideBar.addClass("bundle-need-to-update");
        },
        increaseCartQuantity: function (btnSelector) {
            const variantID = $(btnSelector).attr('data-variant');
            const variantId = parseInt(variantID);
            const item = this.cart[variantId];
            if (!item) return;
            this.cart[variantId].quantity += 1;
            this.calculateCartTotal();
            this.renderCartItems();
            this.makeCartNeedToUpdate();
            this.updateCartStorage();
        },
        decreaseCartQuantity: function (btnSelector) {
            const variantID = $(btnSelector).attr('data-variant');
            const variantId = parseInt(variantID);
            const item = this.cart[variantId];
            if (!item) return;
            if (item.quantity > 1) {
                this.cart[variantId].quantity -= 1;
            } else {
                delete this.cart[variantId];
            }
            this.calculateCartTotal();
            this.renderCartItems();
            this.makeCartNeedToUpdate();
            this.updateCartStorage();
        },
        setCartQuantity: function (inputSelector) {
            const input = $(inputSelector);
            const variantID = input.attr('data-variant');
            const quantity = input.val();
            const variantId = parseInt(variantID);
            const qty = parseInt(quantity);
            const item = this.cart[variantId];
            if (!item) return;
            if (qty <= 0) {
                delete this.cart[variantId];
            } else {
                this.cart[variantId].quantity = qty;
            }
            this.calculateCartTotal();
            this.renderCartItems();
            this.makeCartNeedToUpdate();
            this.updateCartStorage();
        },
        addProductToCart: async function (atcButtonSelector, isModalAtc = false) {
            const btn = $(atcButtonSelector);
            const productId = btn.attr('data-product');
            const parent = btn.closest(isModalAtc ? '.modal' : '.bundle-product');
            const variantOption = parent.find(isModalAtc ? ".qv-add-to-cart select" : '.bundle-variant-select').val();
            const product = this.collections[this.getCollectionHandle()]?.products?.[productId]?.data;
            if (!product) return;

            let variant = product.variants[0];
            if (variantOption && variantOption !== '') {
                const matchedVariant = product.variants.find(v => v.options.includes(variantOption));
                if (matchedVariant) {
                    variant = matchedVariant;
                }
            }
            const variantExist = this.cart[variant.id];
            if (variantExist) {
                this.cart[variant.id].quantity += 1;
                this.showSuccessAlert(`Added another ${product.title}${product.variants.length > 1 ? ` - ${variant.options[0]} ${product.options[0]}` : ''} to cart.`);
            } else {
                this.cart[variant.id] = {
                    variant: variant,
                    quantity: 1,
                    product: product
                };
                this.showSuccessAlert(`Added ${product.title}${product.title}${product.variants.length > 1 ? ` - ${variant.options[0]} ${product.options[0]}` : ''} to cart.`);
            }

            this.calculateCartTotal();
            this.renderCartItems();
            this.makeCartNeedToUpdate();
            this.updateCartStorage();
        },

        initialProductLoad: async function () {
            const params = this.getProductLoadParams();
            if (!params.handle) return;
            let collection = this.collections[params.handle];
            if (collection?.sortKey !== sortBy.val()) {
                this.resetCollection();
                collection = undefined;
            }
            if (collection && collection.products) {
                this.renderProductsFromCache();
            } else {
                pageLoader.show();
                await this.fetchProductHtml(params.handle, 1, params.sortKey).then(html => {
                    content.html(html);
                });
                pageLoader.hide();
            }
            this.updateData();

        },
        getCollectionHandle: function () {
            let $button = $(`.bundle-navs .nav-active button`)
            if(window.innerWidth <= 991){
                $button = $(`.bundle-categories .bundle-navs .nav-active button`)
            }
            if (!$button.length) return null;
            return $button.data("collection");
        },
        getProductLoadParams: function () {
            let handle = this.getCollectionHandle();
            if (!handle) return {};
            const sortKey = sortBy.val()
            const collection = this.collections[handle];
            const info = {
                handle: handle,
                page: collection?.current_page ?? 1,
                sortKey: sortKey,
            }
            return info;
        },

        filterCollection: async function () {
            this.resetCollection();
            const params = this.getProductLoadParams();
            if (!params.handle) return;
            pageLoader.show();

            await this.fetchProductHtml(params.handle, 1, sortBy.val()).then(html => {
                content.html(html);
            });
            pageLoader.hide();
            this.updateData();
        },
        renderProductsFromCache: function () {
            const handle = this.getCollectionHandle();
            const collection = this.collections[handle];
            if (!collection || !collection.products) return;

            let html = '';
            for (const key in collection.products) {
                html += collection.products[key].html;
            }
            content.html(html);
        },
        resetCollection: function () {
            const handle = this.getCollectionHandle();
            if (!handle) return;
            this.collections[handle] = undefined;
            const prods = {};
            if (window.bundleCollections?.[handle]) {
                delete window.bundleCollections[handle];
            }
        },
        updateSubscriptionFrequency: function () {
            const cartValues = Object.values(this.cart);
            const collValues = Object.values(window.bundleCollections ?? {});
            const cartProds = cartValues.map(item => item.product);
            const collProds = collValues.map(col => Object.values(col.products)).flat();
            const prods = cartProds.length ? cartProds : collProds;
            const sellingPlans = prods.find(p => p.selling_plan_groups && p.selling_plan_groups.length > 0 && p.selling_plan_groups.some(g => g.name?.toLowerCase() === "subscribe"))?.selling_plan_groups?.filter(g => g.name?.toLowerCase() === "subscribe")[0]?.selling_plans || [];

            let html = "";
            sellingPlans.forEach((plan, i) => {
                html += `<option ${i === 0 ? `selected=""` : ""} value="${plan.id}">${plan.name}</option>`;
            });
            $(".bundle-frequency-select").html(html);
        },
        updateData: function () {
            $(".bundle-temp-script").remove();
            const handle = this.getCollectionHandle();
            let collection = this.collections[handle] ?? {};
            const bundleCollection = window.bundleCollections?.[handle] || {};

            collection.current_page = bundleCollection?.current_page ?? 1;
            collection.next_page = bundleCollection?.next_page ?? false;
            collection.sortKey = bundleCollection?.sort_by ?? null;
            const prods = collection.products ?? {};
            for (const key in bundleCollection.products) {
                const elem = $(`.bundle-product[data-id="${key}"]`);
                elem.find(`.lazyloading`).removeClass('lazyloading');
                prods[key] = {
                    data: bundleCollection.products[key],
                    html: elem.prop('outerHTML')
                }
            }
            collection.products = prods;
            this.collections[handle] = collection;
            paginate.attr("data-disabled", collection.next_page ? "false" : "true");
            sortBy.prop("value", collection.sortKey);
        },
        getCurrencyFormat: function () {
            return Currency.moneyFormats?.[Shopify.currency.active]?.[Currency.format];
        },
        handleVariantChange: function (variantSelector) {
            const parent = $(variantSelector).closest('.bundle-product');
            const handle = this.getCollectionHandle();
            const collection = this.collections[handle];
            if (!collection) return;

            const productId = parent.data('id');
            const productData = collection.products[productId]?.data;
            if (!productData) return;
            const variant = productData.variants.find(v => v.options.includes($(variantSelector).val()));
            if (variant) {
                // Update price
                const productPrice = variant.price ? theme.Currency.formatMoney(variant.price, this.getCurrencyFormat()) : '';
                const priceEl = parent.find(".product-card__price");
                priceEl.text(productPrice);

                let compareElem = parent.find('.product-card__regular-price');
                // Update compare at price
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    const comparePrice = theme.Currency.formatMoney(variant.compare_at_price, this.getCurrencyFormat());
                    if (!compareElem.length) {
                        compareElem = $('<s class="product-card__regular-price"></s>').appendTo(priceEl);
                    }
                    compareElem.text(comparePrice).show();
                } else {
                    compareElem.text('').hide();
                }
                // Update image
                if (variant.featured_image) {
                    const imageSrc = variant.featured_image.src.replace(/(\.[^.]*)$/, `_small$1`);
                    parent.find('.product-card__image img').attr('src', imageSrc);
                }
                if (variant.available) {
                    parent.find(".product-card__availability").hide();
                    parent.find(".bundle-btn-cta").show();
                } else {
                    parent.find(".product-card__availability").show();
                    parent.find(".bundle-btn-cta").hide();
                }
            }
            theme.updateCurrencies();
        },
        updateCartAjax: async function () {
            const dataToAdd = [];
            const sellingPlan = $(".bundle-purchase-option-input:checked").closest('.bundle-purchase-option').find('.bundle-frequency-select').val();
            const randomBundleID = Math.random().toString(36).substring(2, 15);
            const products = Object.values(this.cart);
            products.forEach((item, index) => {
                const d = {
                    id: item.variant.id,
                    quantity: item.quantity,
                    properties: {
                        _bundle_item: true,
                        _bundle_action_id: randomBundleID,
                        _bundle_title: "Your Own Bundle",
                        _total_bundle_products: products.length,
                        _product_position_order: index + 1,
                    }
                };
                if (sellingPlan) {
                    d.selling_plan = sellingPlan;
                }
                dataToAdd.push(d);
            })
            return await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: dataToAdd
                })
            })
                .then(r => r.json())
        },
        loadMore: function () {
            let params = this.getProductLoadParams();
            if (!params.handle) return;

            new InfiniteScroll({
                gridSelector: ".bundle-paginate-content",
                paginationSelector: ".bundle-pagination",
                offset: 10,
                loadMoreText: '<div class="text-center"><div class="' + theme.loadingClass + '" role="status"></div></div>',
                async callback() {
                    const params = apollo.getProductLoadParams();
                    await apollo.fetchProductHtml(params.handle, (params.page ?? 0) + 1, params.sortKey).then(html => {
                        content.append(html);
                        apollo.updateData();
                    });
                }
            });
        },
        openSideBar: function(){
            $("#categories_block")[0].style.display = "block"
            setTimeout(() => {
                $("#categories_block").addClass("active-nav");
            }, 10);
        },
        closeSideBar: function(){
            $("#categories_block").removeClass("active-nav");
            setTimeout(() => {
                $("#categories_block")[0].style.display = "none"
            }, 105);
        },
        adjustSliderBtnPosition: function(){
            const w = $(".slide-opener-btn").width() ?? 0;
            $(".slide-opener-btn")[0].style.left = "-" + ((w / 2) - 4) + "px";
        }
    }

    $(document).on('click', '.bundle-category-changer', function () {
        if (!$(this).parent().hasClass("nav-active")) {
            $(".bundle-navs li").removeClass("nav-active");
            $(this).parent().addClass("nav-active");
            apollo.initialProductLoad();
        }
        const txt = $(this).text().trim()
        $(".slide-opener-btn").text(txt.toLowerCase() === "all" ? "Categories" : txt)
        apollo.closeSideBar();
        apollo.adjustSliderBtnPosition();
    })

    $(document).on("click", ".slide-opener-btn", function(){
        apollo.openSideBar()
    })

    $(document).on("click", '.bundle-remove-product', function () {
        apollo.handleRemoveProduct(this);
    })

    $(document).on("click", '.bundle-btn-cta,.bundle-btn-cta-qv', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        apollo.addProductToCart(this, $(this).hasClass('bundle-btn-cta-qv'));
        $('#jsQuickview').modal("hide")
    })

    $(document).on('change', '.bundle-variant-select', function () {
        apollo.handleVariantChange($(this));
    })

    $(document).on('change', '#bundle-sortby', function () {
        apollo.filterCollection();
    })

    $(document).on('click', '.bundle-qty-btn-plus', function () {
        apollo.increaseCartQuantity($(this));
    });
    $(document).on('click', '.bundle-qty-btn-minus', function () {
        apollo.decreaseCartQuantity($(this));
    })
    $(document).on('change', '.bundle-qty-input', function () {
        apollo.setCartQuantity($(this));
    })
    $(document).on('change', sellingPlanInput, function () {
        apollo.calculateCartTotal();
    })

    apollo.updateData();
    apollo.updateSubscriptionFrequency();

    (async () => {
        await apollo.syncStorage();
        apollo.calculateCartTotal();
        apollo.updateSubscriptionFrequency();
        apollo.renderCartItems();
        apollo.makeCartNeedToUpdate();
    })()

    document.addEventListener("DOMContentLoaded", function () {
        apollo.loadMore()
    });

    $(document).on('click', "#categories_block", function(ev){
        if(!ev.target?.closest(".bundle-categories-inner")){
            apollo.closeSideBar()
        }
    })

    document.querySelector(".bundle-add-to-cart-btn-wrapper").addEventListener("click", async function (ev) {
        const btn = $(this).find('.bundle-add-to-cart-btn');
        if (btn.hasClass("btn-disabled")) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            return;
        } else {
            ev.preventDefault();
            ev.stopImmediatePropagation();let preInner = btn.html();
            let loader = `<div class="spinner-border" style="height: 15px; width: 15px;border-width: 3px;" role="status"><span class="sr-only">Loading...</span></div>`;
            btn.html(loader);
            btn.prop("disabled", true);
            await apollo.updateCartAjax().then(res => {
                if(!!res.items || !res.status || res.status === 200){
                    window.location.href = btn.attr("data-cart_url");
                    localStorage.removeItem(apollo.storageKey);
                }else{
                    apollo.showErrorAlert(res.description ?? "Something went wrong!")
                    btn.html(preInner)
                    btn.prop("disabled", false);
                }
            })
            // btn.removeClass("bundle-need-to-update");
            // localStorage.removeItem(apollo.storageKey);
            // window.location.href = btn.attr("data-cart_url");
        }

    }, { capture: true })

    return apollo;
})()